module.exports = __webpack_public_path__ + "assets/img/returnBtn-0ff0c3f2.png";